import { StyleProps } from '@chakra-ui/react';

export const rowProps: StyleProps = {
  paddingY: '2',
  paddingX: '4',
  fontSize: 'md',
  fontWeight: 'normal',
};
